/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna pro vytváření chybových objektů při registraci zařízení.
 */
class SetupErrorFactory {
  /**
   * Vytvoří instanci továrny.
   * @param {Class.<SetupError>} SetupError Konstruktor registrační chyby.
   */
  constructor(SetupError) {
    this.SetupError = SetupError;
  }

  /**
   * Vytvoří nový chybový objekt.
   * @param {SetupErrorType} type
   * @returns {SetupError}
   */
  create(type) {
    return new this.SetupError(type);
  }
}

export default SetupErrorFactory;
